/* 门户的相关配置信息 */

let tenderProjectCategory = {
  "cBuild":"A01A01",    //工程建设分类" +
  "cBuildText":"工程建设",    //工程建设名称" +
  "govPur":"A01A02",    //政府采购建设分类
  "govPurText":"政企采购",    //政府采购建设分类
  "entPur":"A01A03",    //企业采购建设分类
  "entPurText":"土地矿业",    //企业采购建设分类
  "proRight":"A01A04",  //国有产权建设分类
  "proRightText":"产权交易",  //国有产权建设分类
  "other":"A01A05",     //其他建设分类
  "otherText":"其他",     //其他建设分类
}

let newsClassifyCode = {
  "news":"A01A03",   //新闻动态
  "notice":"A01A03A01",   //公告通知
  "industry":"A01A03A02",   //行业动态
  "poAndRe":"A01A04",   //政策法规
  "serviceCentre":"A01A02",   //服务中心
  "link":"A01A05"
}

export {
  tenderProjectCategory,newsClassifyCode
}